import { useMemo } from 'react';
import PropTypes from 'prop-types';

import useDetailTable from '#/hooks/table/useDetailTable';
import DetailTable from '#/modules/commonComponents/table/DetailTable';
import { buildStockTransferLineColumns } from '#/modules/imsMgmt/receipts/stockTransfer/columns/stockTransferLineColumns';

const StockTransferLinesTable = ({ lines = [], status }) => {
  const showCompletedFields = status === 'COMPLETED';
  const columns = useMemo(
    () => buildStockTransferLineColumns({ showCompletedFields }),
    [showCompletedFields],
  );

  const rows = useMemo(
    () => (lines ?? []).map((line, index) => ({
      ...line,
      id: line.sourceInvStock?.id
        ? `${line.sourceInvStock.id}-${index}`
        : `line-${index}`,
    })),
    [lines],
  );

  const detailTableState = useDetailTable(rows, columns, {
    enableExpanding: false,
    getRowId: (row) => String(row.id),
  });

  return (
    <div className="detail-table-container">
      <DetailTable
        state={detailTableState}
        containerClassName="detail-table-scroll--section-embedded"
        tableClassName="detail-table--flat-lines"
      />
    </div>
  );
};

StockTransferLinesTable.propTypes = {
  lines: PropTypes.arrayOf(PropTypes.object),
  status: PropTypes.string,
};

export default StockTransferLinesTable;
